import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Dispatch, AppState } from 'store/types'
import { createAccount } from 'ducks/auth/operations'
import CreateAccountForm from 'components/auth/CreateAccountForm'
import { routePath, history } from 'routes'
import LogoTip from '../../components/UI/LogoTip/index.js'

class CreateAccountPage extends Component<Props, {}> {
  render() {
    // tslint:disable-next-line:no-shadowed-variable
    const { createAccount, isAccountCreated } = this.props

    if (isAccountCreated) {
      history.push(routePath.CHECK_EMAIL)
      return null
    }

    // if (isAuthenticated) {
    //   return <Redirect to={routePath.ESTIMATES_PAGE} />
    // }

    return (
      <CenteredBlock>
        <LogoTip />
        <CreateAccountForm onSubmit={createAccount} />
      </CenteredBlock>
    )
  }
}

// tslint:disable-next-line:no-empty-interface
interface ReceivedProps {}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps & DispatchProps & ReceivedProps

const mapStateToProps = (state: AppState) => ({
  isAccountCreated: state.auth.registrationData,
  isAuthenticated: state.auth.isAuthenticated
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ createAccount }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAccountPage)

const CenteredBlock = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

// const LogoTip = styled.div`
//   //background: #fff;
//   // background: url(${logo});
//   background-size: cover;
//   width: 100px;
//   height: 100px;
//   margin-bottom: 1.5rem;
// `
